import { _request, APIBaseResponse, APIMethod } from '../';
import { buildQueryParams } from '../apiHelpers';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const ACL_CONDITIONS_PATH_PREFIX = 'aclconditions';

type APIAclConditionsGetParams = RequestParamsBase & {
    key: string;
};

export type AclCondition = {
    name: string;
    key: string;
};

export type APIAclConditionsGetResponse = APIBaseResponse<Array<AclCondition>>;

export const APIAclConditionGetList: APIMethod<APIAclConditionsGetParams, APIAclConditionsGetResponse> = (params: APIAclConditionsGetParams) => (
    _request('GET', CreateGetRequestPath(params))
);

const CreateGetRequestPath = (params: APIAclConditionsGetParams): string => {
    const queryParams = buildQueryParams(params);
    return `/${ACL_CONDITIONS_PATH_PREFIX}` + (queryParams ? `?${queryParams}` : '');
};
